"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var _getVersionQuery = _interopRequireDefault(require("./getVersionQuery"));
var _getRegisteredAppVersion = _interopRequireDefault(require("./getRegisteredAppVersion"));
var getComponentVersion = function getComponentVersion(props, appConfig) {
  var envKey = props.versionEnvKey,
    versionKey = props.versionKey,
    param = props.versionParam;
  var key = _modalLoaderUtils.HELPERS.titleToCamel(versionKey);
  var specifiedVersion = (0, _getVersionQuery.default)(param || key, envKey) || (0, _getRegisteredAppVersion.default)(props, appConfig, key);
  var _appConfig$branches = appConfig.branches,
    branches = _appConfig$branches === void 0 ? {} : _appConfig$branches;
  return branches[specifiedVersion] || specifiedVersion;
};
var _default = exports.default = function _default(props, appConfig) {
  var version = getComponentVersion(props, appConfig);
  var isLocal = _modalLoaderUtils.HELPERS.isLocal(version);
  var cdnUrl = _modalLoaderUtils.HELPERS.getCdnBaseUrl(props, isLocal);
  return {
    cdnUrl: cdnUrl,
    isLocal: isLocal,
    version: version
  };
};